/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1CourseregistrationEnrollmentCancelMutationRequest,
  PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
  PostApiV1CourseregistrationEnrollmentCancel400,
  PostApiV1CourseregistrationEnrollmentCancel401,
  PostApiV1CourseregistrationEnrollmentCancel500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentCancel.ts";

function getPostApiV1CourseregistrationEnrollmentCancelUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/courseregistration/enrollment/cancel` as const,
  };
  return res;
}

/**
 * @description Altera o status da matrícula para Cancelado em Inscrição (CanceledInRegistration), cancela todas as parcelas em aberto do plano financeiro principal ativo e recusa o vínculo de bolsa quando aplicável. Os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Cancela uma matrícula em inscrição (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/cancel}
 */
export async function postApiV1CourseregistrationEnrollmentCancel(
  data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentCancelMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentCancel400
      | PostApiV1CourseregistrationEnrollmentCancel401
      | PostApiV1CourseregistrationEnrollmentCancel500
    >,
    PostApiV1CourseregistrationEnrollmentCancelMutationRequest
  >({
    method: "POST",
    url: getPostApiV1CourseregistrationEnrollmentCancelUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
